import styled from "styled-components";

export const Sekcja = styled.section`
  position: relative;
  min-height: 760px;
  padding: 150px clamp(16px, 5vw, 72px) 70px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.82fr);
  align-items: center;
  gap: clamp(28px, 6vw, 80px);
  overflow: hidden;
  background: radial-gradient(circle at 86% 18%, rgba(255, 169, 0, 0.18), transparent 24%), linear-gradient(135deg, #fffdf8 0%, #f5f1e7 100%);

  &::before { content: ""; position: absolute; width: 480px; height: 480px; right: -210px; bottom: -260px; border: 70px solid rgba(28, 93, 39, 0.07); border-radius: 50%; }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    min-height: auto;
    padding-top: 118px;
    grid-template-columns: 1fr;
  }
`;

export const Opis = styled.div`position: relative; z-index: 1; max-width: 700px;`;

export const Wstep = styled.p`
  display: inline-flex; margin: 0 0 18px; padding: 8px 14px; border-radius: 999px;
  background: rgba(28, 93, 39, 0.1); color: ${({ theme }) => theme.color.green}; font-size: 14px; font-weight: 800;
`;

export const Tytul = styled.h1`
  max-width: 680px; margin: 0; font-size: clamp(44px, 6.5vw, 78px); line-height: 0.98; letter-spacing: -0.055em;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    font-size: 36px;
    line-height: 1.02;
  }
`;

export const Haslo = styled.p`
  max-width: 650px; margin: 16px 0 0; color: ${({ theme }) => theme.color.green};
  font-size: clamp(25px, 3.4vw, 42px); font-weight: 900; line-height: 1.08; letter-spacing: -0.035em;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) { font-size: 25px; }
`;

export const Paragraf = styled.p`
  max-width: 590px; margin: 26px 0; color: #555a55; font-size: 19px; line-height: 1.6;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) { font-size: 17px; margin: 20px 0; }
`;
export const Przyciski = styled.div`display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin: 28px 0;`;

export const Przycisk = styled.a`
  display: inline-flex; align-items: center; justify-content: center; min-height: 54px; padding: 0 28px;
  border-radius: 999px; background: ${({ theme }) => theme.color.orange}; color: ${({ theme }) => theme.color.black};
  font-size: 14px; font-weight: 900; text-decoration: none; text-transform: uppercase; box-shadow: 0 12px 28px rgba(255, 169, 0, 0.25);
`;

export const Odnosnik = styled.a`
  display: inline-flex; align-items: center; min-height: 54px; padding: 0 24px; border: 1px solid rgba(29, 29, 27, 0.15);
  border-radius: 999px; color: inherit; font-weight: 800; text-decoration: none;
`;
export const ToolsHint = styled.p`
  max-width: 560px;
  margin: -14px 0 22px;
  color: #6b706b;
  font-size: 13px;
  line-height: 1.5;
`;
export const Strzalka = styled.img`width: 10px; height: 10px; margin-left: 8px;`;
export const Opinie = styled.a`
  display: flex; align-items: center; width: fit-content; gap: 4px; margin-top: 18px;
  color: inherit; text-decoration: none;
`;
export const Ocena = styled.strong`margin-right: 8px; font-size: 24px;`;
export const Podstawa = styled.p`margin: 4px 0 0; color: #6b706b; font-size: 13px;`;
export const Gwiazda = styled.img`width: 20px; height: 20px;`;

export const PhotoCard = styled.div`
  position: relative; z-index: 1; align-self: center; justify-self:center; width:100%; max-width:360px; min-height:0; border-radius: 36px; overflow: hidden;
  background: #fff; box-shadow: 0 30px 80px rgba(22, 54, 29, 0.2);
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) { min-height:0; }
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) { min-height:0; border-radius: 26px; }
`;

export const Zdjecie = styled.img`display:block; width:100%; height:auto; min-height:0; object-fit:contain; object-position: center center;`;

